<template>
  <div>
    <strong
      class="text-info text-center w-100 fs_16 chart_title"
      v-text="title"
    />
    <div class="chartWrapper mt-3">
      <div
        class="chartSlice"
        v-for="(item, index) in data"
        :key="index"
        :class="`slice_${index + 1} bg-${renderScoreClass(item.value)}`"
      >
        <!-- <span
          :class="`fs_12 text-${renderScoreClass(item.value)}`"
          v-html="`&#9632; ${item.value}`"
        /> -->
        <strong class="text-white" v-text="item.label" />
      </div>
    </div>
  </div>
</template>
<script>
import { pathOr } from "ramda";

export default {
  props: {
    title: {
      type: String,
      default: "",
    },
    data: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    renderScoreClass(value = null) {
      value = (value && value.trim()) || value;
      const data = {
        "احراز قوت بارز": "success",
        "احراز ضعف بارز": "danger",
        "عدم احراز ضعف یا قوت بارز": "warning",
      };
      return pathOr("white", [value], data);
    },
  },
};
</script>
<style lang="scss">
.chart_title {
  position: relative;
  z-index: 1;
  left: 0;
  right: 0;
}
.label_rotate {
  position: absolute;
  z-index: 1;
}
.chartWrapper {
  width: 200px;
  height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-flow: wrap;
  margin: auto;
  &::after {
    content: "";
    width: 300px;
    height: 300px;
    position: absolute;
    border: 55px solid #fff;
    border-radius: 200px;
  }
  .chartSlice {
    width: 50%;
    height: 50%;
    border: 1px solid #fff;
    color: #fff;
    span {
      width: 60px;
      word-break: break-word;
    }
    &.slice_1 {
      span {
        @extend .label_rotate;
        margin-top: 10px;
        margin-right: -90px;
      }
      strong {
        position: absolute;
        margin: 60px -10px 0 0;
      }
    }
    &.slice_2 {
      span {
        @extend .label_rotate;
        margin-top: 10px;
        margin-right: 30px;
      }
      strong {
        position: absolute;
        margin: 60px -30px 0 0;
      }
    }
    &.slice_3 {
      span {
        @extend .label_rotate;
        margin-top: 50px;
        margin-right: -90px;
      }
      strong {
        position: absolute;
        margin: 15px 0 0 0;
      }
    }
    &.slice_4 {
      span {
        @extend .label_rotate;
        margin-top: 50px;
        margin-right: 25px;
      }
      strong {
        position: absolute;
        margin: 15px -30px 0 0;
      }
    }
  }
}
@media (max-width: 575.98px) {
}
</style>